import { useContext } from 'react';
import { AuthContext } from '@/context/auth';
import { toast } from 'react-hot-toast';

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export function getAuthErrorMessage(error: any): string {
  if (!error) return 'An unknown error occurred';
  
  // Handle specific auth errors
  if (error.message?.toLowerCase().includes('invalid login credentials')) {
    return 'Invalid email or password';
  }
  
  if (error.message?.toLowerCase().includes('email not confirmed')) {
    return 'Please verify your email address';
  }
  
  if (error.message?.toLowerCase().includes('rate limit')) {
    return 'Too many attempts. Please try again later';
  }
  
  if (error.message?.toLowerCase().includes('already registered')) {
    return 'This email is already registered';
  }

  if (error.message?.toLowerCase().includes('refresh_token_not_found')) {
    return 'Your session has expired. Please sign in again.';
  }
  
  return error.message || 'An error occurred during authentication';
}